import { Form, Formik } from "formik";
import { Eye, EyeOff } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FormField } from "@/components/common";
import { passwordSchema } from "../utils";

const PasswordSection = ({ onSubmit, toggles }) => (
  <Card className="border-border/70 h-[440px] flex flex-col">
    <CardHeader>
      <CardTitle className="text-primary">Password Update</CardTitle>
    </CardHeader>
    <CardContent className="flex flex-col flex-1">
      <Formik
        initialValues={{
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        }}
        validationSchema={passwordSchema}
        onSubmit={onSubmit}
      >
        {({ values, errors, touched, handleChange, isSubmitting }) => (
          <Form className="flex flex-col flex-1">
            <div className="space-y-4">
              {[
                {
                  key: "currentPassword",
                  label: "Current Password",
                  toggleKey: "current",
                },
                { key: "newPassword", label: "New Password", toggleKey: "new" },
                {
                  key: "confirmPassword",
                  label: "Confirm Password",
                  toggleKey: "confirm",
                },
              ].map(({ key, label, toggleKey }) => {
                const shown =
                  toggles[
                    `show${toggleKey.charAt(0).toUpperCase() + toggleKey.slice(1)}`
                  ];
                return (
                  <FormField
                    key={key}
                    label={label}
                    type={shown ? "text" : "password"}
                    name={key}
                    value={values[key]}
                    onChange={handleChange}
                    error={touched[key] && errors[key]}
                    required
                    rightIcon={
                      <button
                        type="button"
                        onClick={() => toggles.toggle(toggleKey)}
                      >
                        {shown ? (
                          <EyeOff className="h-4 w-4" />
                        ) : (
                          <Eye className="h-4 w-4" />
                        )}
                      </button>
                    }
                  />
                );
              })}
            </div>
            <div className="mt-auto pt-6 flex justify-end">
              <Button type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Saving..." : "Save Changes"}
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </CardContent>
  </Card>
);

export default PasswordSection;
